import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-minus",
  "use": "icon-minus-usage",
  "viewBox": "0 0 29 29",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 29 29\" id=\"icon-minus\"><g transform=\"translate(1.247 1.616)\" stroke=\"#1B7F9D\" fill=\"none\" fill-rule=\"evenodd\"><circle stroke-width=\"1.12\" cx=\"13.078\" cy=\"13.078\" r=\"13.078\" /><path stroke-width=\"1.4\" fill=\"#1B7F9D\" stroke-linecap=\"round\" d=\"M8.038 12.924h10.08\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol